import { Component, OnInit, Input } from '@angular/core';
import { Value, PaymentCapacity, Department, City, Reference, Petition, Applicant, LogsNav } from '../../interfaces/interfaces.index';
import { NgModel, NgForm } from '@angular/forms';
import { NgbDate, NgbDateAdapter, NgbDateNativeAdapter, NgbDatepickerI18n, NgbDateParserFormatter, NgbDatepickerConfig, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { EMAIL_PATTERN } from '../../shared/config/config';
import { numberIntMask, phoneMask, cellularMask, ciiuMask, numberCMask, nameMask } from '../../shared/config/imaskCommon';
import { I18n, CustomDatepickerI18n, DateFormatService, ValueService, LogsService, UserService } from '../../services/services.index';
import {
  Spouse, EcoActivApplicant, FinancialInfo, Peps,
  AuthorizeDeclare, Account, SecondHoldert
} from '../../interfaces/payment-capacity';
import Swal from 'sweetalert2';
import { swalError } from 'src/app/shared/config/swalCommon';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-capacidad-pago-m',
  templateUrl: './capacidad-pago-m.component.html',
  styleUrls: ['./capacidad-pago-m.component.css'],
  providers: [I18n,
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: NgbDateParserFormatter, useClass: DateFormatService }
  ]
})
export class CapacidadPagoMComponent implements OnInit {
  @Input() paymentCapacity: PaymentCapacity = {
    petition: {} as Petition,
    role: {} as Value,
    debtor: {} as Value,
    applicant: {} as Applicant,
    spouse: {} as Spouse,
    ecoActivApplicant: {
      job: {} as Value,
      contract: {} as Value
    } as EcoActivApplicant,
    financialInfo: {
      assetsDetail: {} as Value
    } as FinancialInfo,
    references: [],
    peps: {} as Peps,
    authorizeDeclare: {} as AuthorizeDeclare,
    account: {
      secondHolder: {} as SecondHoldert
    } as Account
  } as PaymentCapacity;
  @Input() viewMode: boolean;
  loadValues: boolean;
  values: Value[] = [];
  tp: Value[] = [];
  tt: Value[] = [];
  td: Value[] = [];
  s: Value[] = [];
  ec: Value[] = [];
  na: Value[] = [];
  tv: Value[] = [];
  ese: Value[] = [];
  act: Value[] = [];
  emp: Value[] = [];
  tc: Value[] = [];
  c: Value[] = [];
  sa: Value[] = [];
  a: Value[] = [];
  r: Value[] = [];
  tcs: Value[] = [];
  d: Department[] = [];
  c1: City[] = [];
  l1: Value[] = [];
  c2: City[] = [];
  l2: Value[] = [];
  c3: City[] = [];
  l3: Value[] = [];
  c4: City[] = [];
  l4: Value[] = [];
  c5: City[] = [];
  l5: Value[] = [];
  mostrar: boolean;
  hoy: NgbDate;
  hoy18: NgbDate;
  emailPattern = EMAIL_PATTERN;
  numberIntMask = numberIntMask;
  currencyMask = numberCMask;
  phoneMask = phoneMask;
  cellularMask = cellularMask;
  ciiuMask = ciiuMask;
  nameMask = nameMask;
  references: Reference[] = [];
  existeReferencia: boolean;
  country = 'Colombia';
  department: string;
  location: string;
  city: string;

  SPN1: String[] = [
    "no",
    "si"
  ];
  SPN2: String[] = [
    "Deudor",
    "Codeudor"
  ];
  SPN3: String[] = [
    "Deudor1",
    "Deudor2"
  ];

  __cupo__: String[] = [
    "GRUPO",
    "AFILIACIÓN",
    "NIVEL"
  ];

  SPN4: String[] = [
    "CC",
    "CE",
    "TI",
    "NIT"
  ];

  SPN5: String[] = [
    "Soltero",
    "Casado",
    "Unión Libre",
    "Separado / Divorciado",
    "Viudo",
    "Otro",
  ];

  SPN6: String[] = [
    "F",
    "M"
  ];

  SPN7: String[] = [
    "Primaria",
    "Bachillerato",
    "Técnico",
    "Universitario",
    "Especialización",
    "Doctorado"
  ];

  SPN8: String[] = [
    "0","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15"
  ];

  SPN9: String[] = [

  ];

  SPN10: String[] = [
    "Propia",
    "Familiar",
    "Arrendada"
  ];

  SPN11: String[] = [
    "1","2","3","4","5","6"
  ];

  SPN12: String[] = [

    "1 - 6 meses",
    "6 - 12 meses",
    "1 - 2 años",
    "2 - 3 años",
    "3 - 5 años",
    "5 - 8 años",
    "8 - 10 años",
    "Más de 10 años"

  ];

  SPN14: String[] = [

    "Empleado",
    "Independiente",
    "Ingresos por arrendamientos",
    "Pensionado",
    "Trasportador",
    "Contratos por prestación de servicios u Honorarios",
    "Otro"

  ];

  SPN15: String[] = [
    "Temporal",
    "Indefinido",
    "Fijo",
    "Otro"
  ];

  SPN16: String[] = [

    "Ninguno",
    "1 - 2",
    "3 - 4",
    "5 - 7",
    "7 - 10",
    "11 - 15",
    "16 - 20",
    "Más de 20"

  ];

  SPN17: String[] = [
    "F",
    "M"
  ];

  SPN18: String[] = [
    "F",
    "M"
  ];

  SPN19: String[] = [
    "F",
    "M"
  ];

  SPN20: String[] = [
    "F",
    "M"
  ];

  SPN21: String[] = [
    "F",
    "M"
  ];

  SPN22: String[] = [
    "F",
    "M"
  ];

  constructor(
    private valueSevice: ValueService,
    public dpConfig: NgbDatepickerConfig,
    public calendar: NgbCalendar,
    private spinnerService: NgxSpinnerService,
    private logsService: LogsService,
    private userService: UserService,
  ) {
    this.hoy = calendar.getToday();
    this.hoy18 = new NgbDate(this.hoy.year - 18, this.hoy.month, this.hoy.day);
  }

  ngOnInit(): void {
    this.addLogsNav();

    this.getValues();
    this.getUbicacion();
  }

  addLogsNav(){
    const logNav: LogsNav = {
      logType: 'Log de Navegación',
      visitedPage: location.href,
      userId: this.userService.user.id,
      petitionId: 0,
      stepCompleted: ''
    };

  }

  getValues = () => {
    this.loadValues = true;

    const types = ['deudor', 'tramite', 'tipoident', 'sexo', 'estadocivil', 'nivelacademico', 'tipovivienda', 'estratose', 'actividades', 'empleo', 'tipocontrato', 'composicion', 'sectorae', 'activos', 'tiporelacion', 'tipocuenta'];
    this.valueSevice.getValuesGroup(types).subscribe(
      data => {
        const buscar = (type: string) => this.values.filter(x => x.type === type);
        const ordenar = (values: Value[], orderName = true) =>
          values.sort((a, b) => orderName ? a.name.localeCompare(b.name) : parseInt(a.valueId, 0) - parseInt(b.valueId, 0));
        this.values = data;
        this.tp = ordenar(buscar('deudor'));
        this.tt = ordenar(buscar('tramite'));
        this.td = ordenar(buscar('tipoident'));
        this.s = ordenar(buscar('sexo'));
        this.ec = ordenar(buscar('estadocivil'));
        this.na = ordenar(buscar('nivelacademico'), false);
        this.tv = ordenar(buscar('tipovivienda'));
        this.ese = ordenar(buscar('estratose'));
        this.act = ordenar(buscar('actividades'));
        this.emp = ordenar(buscar('empleo'));
        this.tc = ordenar(buscar('tipocontrato'));
        this.c = ordenar(buscar('composicion'));
        this.sa = ordenar(buscar('sectorae'));
        this.a = ordenar(buscar('activos'));
        this.r = ordenar(buscar('tiporelacion'));
        this.tcs = ordenar(buscar('tipocuenta'));
      },
      error => this.handleError(error)
    );
    this.loadValues = false;
  }

  getUbicacion = () => this.valueSevice.getAllUbications().subscribe(data => this.d = data, error => this.handleError(error));

  assignCity = () =>
    this.paymentCapacity.applicant.city = this.location ? this.location : this.city

  registrar() {
  }

  validator = (model: NgModel, form: NgForm) => (!model.untouched && model.invalid || model.invalid && form.submitted);

  requiredField = (field) => {

  }

  resetField = (field) => {

  }

  validateField = (field) => {

  }

  addReference = () => this.paymentCapacity.references;

  removeReference = (i) => this.paymentCapacity.references.splice(i, 1);

  sumTotalIncome() {

  }

  sumTotalLiabilities() {

  }

  handleError = (err) => { this.spinnerService.hide(); Swal.fire(swalError('Ha ocurrido un error', err.error?err.error.userMessage:err.userMessage)); };
}
